module.exports = __webpack_public_path__ + "static/media/logo-black@200x.8f423aa1.png";